import store from '@/store'
import ability from '@/libs/acl/ability'

export default function permission() {
  const getPermissions = letter => {
    const perm = {
      can_send: false,
      can_update: false,
      can_delete: false,
      can_regenerate: false,
      can_create_quote: false,
      can_draft: false,
    }
    const letterPermissions = letter.letter_permissions ? letter.letter_permissions : {}
    return {
      ...perm,
      ...letterPermissions,
    }
  }
  const canUpdate = letter => getPermissions(letter).can_update

  const canDelete = letter => getPermissions(letter).can_delete

  const canRegenerate = letter => getPermissions(letter).can_regenerate

  const canCreateQuote = letter => getPermissions(letter).can_create_quote

  const canSend = letter => getPermissions(letter).can_send

  const canDraft = letter => getPermissions(letter).can_draft

  const canDownloadFile = letter => (letter.letter_status !== store.state.staticModule.letterStatusDraft)

  const canCreateUsual = () => ability.can('create_usual', 'Letter')

  const canCreateTargeted = () => ability.can('create_targeted', 'Letter')

  const canShowQuoteTable = letter => [store.state.staticModule.orgTypeOTM, store.state.staticModule.orgTypeITM].includes(letter.from_org.type_org_id)

  const canExportAcceptedTable = letter => [store.state.staticModule.orgTypeFinance, store.state.staticModule.orgTypeMinistry, store.state.staticModule.orgTypeInnovation].includes(letter.from_org.type_org_id)

  return {
    canUpdate,
    canDelete,
    canSend,
    canRegenerate,
    canCreateQuote,
    canDownloadFile,
    canCreateUsual,
    canCreateTargeted,
    canShowQuoteTable,
    canExportAcceptedTable,
    canDraft,
  }
}
